import React from 'react';
import classnames from 'classnames';

import style from './index.module.less';

/**
 * Component that renders a label with a red asterisk indicator for required fields.
 * The asterisk is aligned to the baseline of the label text.
 * @param {object} props
 * @param {React.ReactNode} props.children - The label content (text, formatted message, etc.)
 * @param {boolean} [props.required] - Whether to show the required asterisk
 * @param {string} [props.className] - Additional CSS classes
 * @returns {React.ReactElement} The label element with optional required indicator
 */
export const LabelWithRequiredIndicator = ({ children, required = true, className, ...rest }) => {
  if (!required) {
    return (
      <span className={className} {...rest}>
        {children}
      </span>
    );
  }

  return (
    <span className={classnames(style['label-with-required'], className)} {...rest}>
      <span>{children}</span>
      <span className={style['required-asterisk']}>*</span>
    </span>
  );
};
